var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_42661_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72917 2.0835C4.80869 2.0835 4.0625 2.82969 4.0625 3.75016V21.2502C4.0625 22.1706 4.80869 22.9168 5.72917 22.9168H19.2708C20.1913 22.9168 20.9375 22.1706 20.9375 21.2502V7.29183L15.7292 2.0835H5.72917Z",
    fill: "#FA4E4E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8835 16.1141C15.1805 16.0618 14.5036 15.8008 13.9569 15.3309C12.8895 15.5658 11.874 15.9051 10.8586 16.3229C10.0516 17.7587 9.29648 18.4897 8.64557 18.4897C8.51536 18.4897 8.35924 18.4637 8.25508 18.3853C7.96862 18.2548 7.8125 17.9676 7.8125 17.6805C7.8125 17.4454 7.86458 16.7928 10.3379 15.7224C10.9108 14.6781 11.3533 13.6078 11.7178 12.4853C11.4053 11.8587 10.7285 10.3184 11.197 9.53528C11.3533 9.24804 11.6658 9.0914 12.0043 9.11758C12.2646 9.11758 12.5249 9.24804 12.6811 9.4569C13.0197 9.92682 12.9936 10.9189 12.5509 12.3809C12.9676 13.1629 13.5133 13.869 14.1651 14.4694C14.712 14.3648 15.2586 14.2866 15.8053 14.2866C17.029 14.3126 17.2113 14.887 17.1853 15.2264C17.1853 16.1141 16.326 16.1141 15.8835 16.1141ZM8.59362 17.7325L8.67174 17.7065C9.0362 17.576 9.32253 17.315 9.53086 16.9755C9.14023 17.1322 8.82786 17.3932 8.59362 17.7327V17.7325ZM12.0563 9.90078H11.9781C11.9521 9.90078 11.9 9.90078 11.874 9.92682C11.7698 10.3706 11.8479 10.8405 12.0302 11.2582C12.1865 10.8145 12.1865 10.3445 12.0563 9.90078ZM12.2385 13.6862L12.2125 13.7383L12.1865 13.7122C11.9521 14.3128 11.6917 14.9131 11.4053 15.4875L11.4574 15.4615V15.5135C12.0364 15.3036 12.6276 15.1293 13.2279 14.9914L13.2018 14.9654H13.2799C12.8893 14.5737 12.5249 14.1299 12.2385 13.6862ZM15.7793 15.0698C15.5449 15.0698 15.3367 15.0698 15.1023 15.1219C15.3628 15.2525 15.6232 15.3047 15.8835 15.3309C16.0658 15.3569 16.248 15.3309 16.4042 15.2786C16.4042 15.2003 16.3 15.0698 15.7793 15.0698Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4489 6.80322H16.2175L20.9376 11.5233V7.2915L20.4489 6.80322Z",
    fill: "url(#paint0_linear_42661_1917)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 7.2915L15.7292 2.08317C15.7292 4.95965 18.061 7.2915 20.9375 7.2915Z",
    fill: "#FDB8B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_42661_1917",
    x: 4.0625,
    y: 1.0835,
    width: 16.875,
    height: 22.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42661_1917"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_42661_1917",
    result: "effect2_innerShadow_42661_1917"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42661_1917",
    x1: 17.2755,
    y1: 5.74528,
    x2: 21.9955,
    y2: 10.4653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.8f6440b71c0102d5cbe0ae005fa13adf.svg";
export { ForwardRef as ReactComponent };